// List Coupons
export const GET_ACTIVE_CAMPAIGN_LIST_FOR_MONITORING_REQUEST =
  "GET_ACTIVE_CAMPAIGN_LIST_FOR_MONITORING_REQUEST";
export const GET_ACTIVE_CAMPAIGN_LIST_FOR_MONITORING_SUCCESS =
  "GET_ACTIVE_CAMPAIGN_LIST_FOR_MONITORING_SUCCESS";
export const GET_ACTIVE_CAMPAIGN_LIST_FOR_MONITORING_FAIL =
  "GET_ACTIVE_CAMPAIGN_LIST_FOR_MONITORING_FAIL";
export const GET_ACTIVE_CAMPAIGN_LIST_FOR_MONITORING_RESET =
  "GET_ACTIVE_CAMPAIGN_LIST_FOR_MONITORING_RESET";

export const GET_ACTIVE_CAMPAIGN_LIST_SCREEN_WISE_FOR_MONITORING_REQUEST =
  "GET_ACTIVE_CAMPAIGN_LIST_SCREEN_WISE_FOR_MONITORING_REQUEST";
export const GET_ACTIVE_CAMPAIGN_LIST_SCREEN_WISE_FOR_MONITORING_SUCCESS =
  "GET_ACTIVE_CAMPAIGN_LIST_SCREEN_WISE_FOR_MONITORING_SUCCESS";
export const GET_ACTIVE_CAMPAIGN_LIST_SCREEN_WISE_FOR_MONITORING_FAIL =
  "GET_ACTIVE_CAMPAIGN_LIST_SCREEN_WISE_FOR_MONITORING_FAIL";
export const GET_ACTIVE_CAMPAIGN_LIST_SCREEN_WISE_FOR_MONITORING_RESET =
  "GET_ACTIVE_CAMPAIGN_LIST_SCREEN_WISE_FOR_MONITORING_RESET";

export const GET_CAMPAIGN_MONITORING_DATA_REQUEST =
  "GET_CAMPAIGN_MONITORING_DATA_REQUEST";
export const GET_CAMPAIGN_MONITORING_DATA_SUCCESS =
  "GET_CAMPAIGN_MONITORING_DATA_SUCCESS";
export const GET_CAMPAIGN_MONITORING_DATA_FAIL =
  "GET_CAMPAIGN_MONITORING_DATA_FAIL";
export const GET_CAMPAIGN_MONITORING_DATA_RESET =
  "GET_CAMPAIGN_MONITORING_DATA_RESET";

export const ADD_CAMPAIGN_MONITORING_DATA_REQUEST =
  "ADD_CAMPAIGN_MONITORING_DATA_REQUEST";
export const ADD_CAMPAIGN_MONITORING_DATA_SUCCESS =
  "ADD_CAMPAIGN_MONITORING_DATA_SUCCESS";
export const ADD_CAMPAIGN_MONITORING_DATA_FAIL =
  "ADD_CAMPAIGN_MONITORING_DATA_FAIL";
export const ADD_CAMPAIGN_MONITORING_DATA_RESET =
  "ADD_CAMPAIGN_MONITORING_DATA_RESET";

export const GENERATE_MONITORING_PPT_REQUEST =
  "GENERATE_MONITORING_PPT_REQUEST";
export const GENERATE_MONITORING_PPT_SUCCESS =
  "GENERATE_MONITORING_PPT_SUCCESS";
export const GENERATE_MONITORING_PPT_FAIL = "GENERATE_MONITORING_PPT_FAIL";
export const GENERATE_MONITORING_PPT_RESET = "GENERATE_MONITORING_PPT_RESET";

export const GET_MONITORING_PPT_JOB_STATUS_REQUEST =
  "GET_MONITORING_PPT_JOB_STATUS_REQUEST";
export const GET_MONITORING_PPT_JOB_STATUS_SUCCESS =
  "GET_MONITORING_PPT_JOB_STATUS_SUCCESS";
export const GET_MONITORING_PPT_JOB_STATUS_FAIL =
  "GET_MONITORING_PPT_JOB_STATUS_FAIL";
export const GET_MONITORING_PPT_JOB_STATUS_RESET =
  "GET_MONITORING_PPT_JOB_STATUS_RESET";

export const CAMPAIGN_MONITORING_PICS_REQUEST =
  "CAMPAIGN_MONITORING_PICS_REQUEST";
export const CAMPAIGN_MONITORING_PICS_SUCCESS =
  "CAMPAIGN_MONITORING_PICS_SUCCESS";
export const CAMPAIGN_MONITORING_PICS_FAIL = "CAMPAIGN_MONITORING_PICS_FAIL";
